/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Dark_TitleInputs */

const en_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const ar_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الظلام`)
};

const de_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkelheit`)
};

const es_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscuridad`)
};

const fr_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ténèbres`)
};

const it_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscurità`)
};

const ja_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`闇`)
};

const ko_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어둠`)
};

const pt_br_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuridão`)
};

const ru_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тьма`)
};

const th_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความมืด`)
};

const tr_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karanlık`)
};

const zh_cn_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗`)
};

const zh_tw_daily_paywall_exclusive_tree_dark_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Daily_Paywall_Exclusive_Tree_Dark_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_dark_title = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Dark_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Dark_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_dark_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_dark_title(inputs)
	return zh_tw_daily_paywall_exclusive_tree_dark_title(inputs)
});